import { GoogleMaterialIcon } from '../ui/GoogleMaterialIcon';
import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";

import ToolTip from "../common/ToolTip";
import { useCommonDetailsContext } from "../../context/Common/common";
import { tokens } from "../../theme/tokens";

;
;
;
;
;

export default function Toolbox(props: {
  isLoading: boolean;
  approveDraft: () => void;
  addComment: () => void;
  isDisabled: boolean;
  displayAttachments: () => void;
  displayHistory: () => void;
}) {
  const { publishedBranding } = useCommonDetailsContext();
  const primaryColor =
    publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const navigate = useNavigate();

  const setApproveStatus = () => {
    props.approveDraft();
  };

  const setCommentStatus = () => {
    props.addComment();
  };
  const displayAttachments = () => {
    props.displayAttachments();
  };

  const showFilingMasterForm = () => {
    navigate("/filing-master", {
      state: { from: "/filing-master-approval-list", mode: "add" },
    });
  };
  const displayHistory = () => {
    props.displayHistory();
  };
  return (
    <Box sx={{ 
      width: "100%", 
      bgcolor: "white",
      borderRadius: "50px !important",
      padding: "16px 8px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "8px"
    }}>
      <nav aria-label="main mailbox folders" style={{ width: "100%" }}>
        <List disablePadding sx={{ padding: 0 }}>
          <ListItem disablePadding sx={{ justifyContent: "center" }}>
            <ListItemButton disabled={props.isLoading} sx={{ justifyContent: "center", padding: "8px" }}>
              <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                <GoogleMaterialIcon name="filter_list" color={primaryColor} />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding sx={{ justifyContent: "center" }}>
            <ListItemButton
              disabled={props.isLoading}
              onClick={showFilingMasterForm}
              sx={{ justifyContent: "center", padding: "8px" }}
            >
              <ToolTip title="Add Filing Master">
                <GoogleMaterialIcon name="post_add" color={primaryColor} />
              </ToolTip>
            </ListItemButton>
          </ListItem>
        </List>
      </nav>
      <Divider sx={{ width: "80%", bgcolor: primaryColor }} />
      <nav aria-label="secondary mailbox folders" style={{ width: "100%" }}>
        <List sx={{ padding: 0 }}>
          <ListItem disablePadding sx={{ justifyContent: "center" }}>
            <ListItemButton
              disabled={props.isLoading}
              onClick={setCommentStatus}
              sx={{ justifyContent: "center", padding: "8px" }}
            >
              <ToolTip title="Comments">
                <GoogleMaterialIcon name="comment" color={primaryColor} />
              </ToolTip>
            </ListItemButton>
          </ListItem>
          {!props.isDisabled && (
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                disabled={props.isLoading}
                onClick={setApproveStatus}
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Approve/Reject Draft">
                  <GoogleMaterialIcon name="verified_user" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
          )}
          <ListItem disablePadding sx={{ justifyContent: "center" }}>
            <ListItemButton onClick={displayHistory} sx={{ justifyContent: "center", padding: "8px" }}>
              <ToolTip title="Activity History">
                <GoogleMaterialIcon name="history" color={primaryColor} />
              </ToolTip>
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding sx={{ justifyContent: "center" }}>
            <ListItemButton
              onClick={displayAttachments}
              disabled={props.isLoading}
              sx={{ justifyContent: "center", padding: "8px" }}
            >
              <ToolTip title="Reference Documents">
                <GoogleMaterialIcon name="snippet_folder" color={primaryColor} />
              </ToolTip>
            </ListItemButton>
          </ListItem>
          {/* <ListItem disablePadding>
            <ListItemButton>
              <GoogleMaterialIcon name="delete" />
            </ListItemButton>
          </ListItem> */}
        </List>
      </nav>
    </Box>
  );
}
